import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { AdventurePage } from '~/components/Adventure/AdventurePage';
import { AdventureRedirect } from '~/components/Adventure/AdventureRedirect';
import { AdventureErrorFallback } from '~/components/Adventure/Error/AdventureErrorFallback';
import { QueryErrorBoundary } from '~/components/Error';

export const AdventureRouteSwitch = ({ match: { path } }: RouteComponentProps) => (
  <QueryErrorBoundary FallbackComponent={AdventureErrorFallback}>
    <Switch>
      <Route path={path} exact component={AdventureRedirect} />
      <Route path={`${path}/:id`} exact component={AdventurePage} />
    </Switch>
  </QueryErrorBoundary>
);
